var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 81,
    viewBox: "0 0 181 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 141,
    height: 41,
    rx: 10,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M76.7253 46V33.544H78.1113V46H76.7253ZM82.271 46H80.921V37H82.253V37.63C83.153 37.09 84.029 36.82 84.881 36.82C85.997 36.82 86.777 37.126 87.221 37.738C87.617 37.498 88.127 37.288 88.751 37.108C89.387 36.916 89.945 36.82 90.425 36.82C91.625 36.82 92.429 37.144 92.837 37.792C93.257 38.428 93.467 39.58 93.467 41.248V46H92.117V41.284C92.117 40.036 91.997 39.184 91.757 38.728C91.517 38.26 91.007 38.026 90.227 38.026C89.831 38.026 89.423 38.086 89.003 38.206C88.583 38.314 88.259 38.422 88.031 38.53L87.689 38.692C87.845 39.088 87.923 39.964 87.923 41.32V46H86.573V41.356C86.573 40.06 86.453 39.184 86.213 38.728C85.985 38.26 85.475 38.026 84.683 38.026C84.299 38.026 83.903 38.086 83.495 38.206C83.099 38.314 82.793 38.422 82.577 38.53L82.271 38.692V46ZM95.9679 49.996V37H97.2999V37.648C98.2119 37.096 99.1119 36.82 99.9999 36.82C101.14 36.82 101.968 37.186 102.484 37.918C103 38.638 103.258 39.832 103.258 41.5C103.258 43.168 102.952 44.368 102.34 45.1C101.74 45.82 100.738 46.18 99.3339 46.18C98.6019 46.18 97.9299 46.114 97.3179 45.982V49.996H95.9679ZM99.8019 38.026C99.4419 38.026 99.0519 38.086 98.6319 38.206C98.2239 38.326 97.8999 38.446 97.6599 38.566L97.3179 38.746V44.812C98.1699 44.944 98.8179 45.01 99.2619 45.01C100.234 45.01 100.912 44.734 101.296 44.182C101.692 43.63 101.89 42.73 101.89 41.482C101.89 40.234 101.71 39.346 101.35 38.818C101.002 38.29 100.486 38.026 99.8019 38.026ZM105.064 41.482C105.064 39.838 105.358 38.65 105.946 37.918C106.534 37.186 107.524 36.82 108.916 36.82C110.32 36.82 111.31 37.186 111.886 37.918C112.474 38.65 112.768 39.838 112.768 41.482C112.768 43.126 112.492 44.32 111.94 45.064C111.388 45.808 110.38 46.18 108.916 46.18C107.452 46.18 106.444 45.808 105.892 45.064C105.34 44.32 105.064 43.126 105.064 41.482ZM106.45 41.464C106.45 42.772 106.606 43.69 106.918 44.218C107.242 44.746 107.908 45.01 108.916 45.01C109.936 45.01 110.602 44.752 110.914 44.236C111.226 43.708 111.382 42.784 111.382 41.464C111.382 40.144 111.208 39.238 110.86 38.746C110.512 38.242 109.864 37.99 108.916 37.99C107.98 37.99 107.332 38.242 106.972 38.746C106.624 39.238 106.45 40.144 106.45 41.464ZM114.97 46V37H116.302V38.224C117.346 37.504 118.444 37.03 119.596 36.802V38.17C119.092 38.266 118.564 38.416 118.012 38.62C117.472 38.824 117.058 39.004 116.77 39.16L116.32 39.394V46H114.97ZM125.854 38.17H122.992V42.472C122.992 43.504 123.064 44.182 123.208 44.506C123.364 44.83 123.724 44.992 124.288 44.992L125.89 44.884L125.98 46C125.176 46.132 124.564 46.198 124.144 46.198C123.208 46.198 122.56 45.97 122.2 45.514C121.84 45.058 121.66 44.188 121.66 42.904V38.17H120.382V37H121.66V34.246H122.992V37H125.854V38.17Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7398 32L49.6528 35.8927H52.718V42.7317H54.7615V35.8927H57.8267L53.7398 32ZM60.892 45.6683V38.8293H58.8485V45.6683H55.7833L59.8702 49.561L63.9572 45.6683H60.892Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0,
    y: 0,
    width: 181,
    height: 81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.367872c0f45f56b263d5227c0a1815bb.svg";
export { ForwardRef as ReactComponent };